import { render, staticRenderFns } from "./DoKoDeck.vue?vue&type=template&id=614a040c&scoped=true&"
import script from "./DoKoDeck.vue?vue&type=script&lang=ts&"
export * from "./DoKoDeck.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDeck.vue?vue&type=style&index=0&id=614a040c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a040c",
  null
  
)

/* custom blocks */
import block0 from "./DoKoDeck.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports